<template>
  <div class="yxtbiz-register-audit">
    <div class="standard-size-16 color-gray-10">
      <div class="font-bolder">
        {{ $t('pc_biz_sd_register_attribute' /**注册属性 */) }}
      </div>
      <yxtf-row class="mv24 font-normal font-size-14">
        <yxtf-col
          v-for="(item, index) in fields"
          :key="index"
          :span="12"
          class="mb24 pr10"
          style="display: flex"
        >
          <span class="color-gray-7 nowrap">{{ item.fieldName }}：</span>

          <yxtf-image
            v-if="item.fieldType === '4' && item.fieldValue"
            style="width: 100px; height: 100px"
            :src="item.fieldValue"
            :preview-src-list="[item.fieldValue]">
          </yxtf-image>

          <yxtf-tooltip v-else class="yxtbiz-register-audit__text" placement="top" :open-filter="true" :content="item.fieldValue">
            <span>{{ item.fieldValue || '--' }}</span>
          </yxtf-tooltip>
        </yxtf-col>
      </yxtf-row>
    </div>

    <div class="standard-size-16 color-gray-10">
      <div class="font-bolder">
        {{ $t('pc_biz_sd_register_rule' /**注册规则 */) }}
      </div>
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="12" class="pr10 flex">
          <span class="color-gray-7 nowrap"
          >{{ $t('pc_biz_bbs_lbl_dept' /**  部门 */) }}：</span
          >
          <yxtf-tooltip placement="top" :open-filter="true">
            <yxtbiz-dept-name slot="content" :name="configEntity.refDeptName" />
            <yxtbiz-dept-name
              class="yxtbiz-board-audit_ellipsis"
              :name="configEntity.refDeptName || '--'"
            />
          </yxtf-tooltip>
          <yxtf-tag v-if="configEntity.refDeptDeleted" class="yxtbiz-register-audit__tag" type="danger" size="mini">
            {{ $t('pc_biz_kng_lbl_delete'/*删除*/) }}
          </yxtf-tag>
        </yxtf-col>

        <yxtf-col :span="12" class="pr10 flex">
          <span class="color-gray-7 nowrap"
          >{{ $t('biz_udp_usergroup' /**用户组 */) }}：</span
          >
          <div class="yxtbiz-register-audit__groupWrap">
            <div
              class="yxtbiz-register-audit__group"
              v-for="(item, index) in groupList"
              :key="index"
            >
              <yxtf-tooltip
                :open-filter="true"
                placement="top"
                :content="item.name"
                class="yxtbiz-register-audit__text"
              >
                <div>{{ item.name }}</div>
              </yxtf-tooltip>
              <yxtf-tag v-if="item.deleted" class="yxtbiz-register-audit__tag" type="danger" size="mini">
                {{ $t('pc_biz_kng_lbl_delete'/*删除*/) }}
              </yxtf-tag>
            </div>
            <div v-if="!groupList.length">--</div>
          </div>
        </yxtf-col>
      </yxtf-row>
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="12" class="pr10 flex">
          <span class="color-gray-7 nowrap"
          >{{ $t('pc_biz_bbs_lbl_possion' /**岗位 */) }}：</span
          >
          <yxtf-tooltip :open-filter="true" placement="top">
            <yxtbiz-position-name
              slot="content"
              :name="configEntity.refPosiName"
            />
            <yxtbiz-position-name
              class="yxtbiz-board-audit_ellipsis"
              :name="configEntity.refPosiName || '--'"
            />
          </yxtf-tooltip>
          <yxtf-tag v-if="configEntity.refPosiDeleted" class="yxtbiz-register-audit__tag" type="danger" size="mini">
            {{ $t('pc_biz_kng_lbl_delete'/*删除*/) }}
          </yxtf-tag>
        </yxtf-col>
        <yxtf-col :span="12" class="pr10 flex">
          <span class="color-gray-7 nowrap">{{ $t('biz_udp_occupation_level' /**职级 */) }}：</span>
          <yxtf-tooltip
            class="yxtbiz-register-audit__text"
            :open-filter="true"
            placement="top"
            :content="configEntity.refGradeName"
          >
            <div>{{ configEntity.refGradeName || '--' }}</div>
          </yxtf-tooltip>
          <yxtf-tag v-if="configEntity.refGradeDeleted" class="yxtbiz-register-audit__tag" type="danger" size="mini">
            {{ $t('pc_biz_kng_lbl_delete'/*删除*/) }}
          </yxtf-tag>
        </yxtf-col>
      </yxtf-row>
    </div>
  </div>
</template>

<script>
import { FetchRegisterInfo } from './service';
export default {
  name: 'YxtbizRegisterAudit',

  props: {
    id: { type: String }
  },

  data() {
    return {
      fields: [],
      configEntity: {}
    };
  },

  computed: {
    groupList() {
      return this.configEntity.refGroupList || [];
    }
  },

  created() {
    FetchRegisterInfo(this.id).then(res => {
      const { configEntity = {}, fields = [] } = res.data || {};
      this.configEntity = configEntity;
      this.fields = fields;
    });
  }
};
</script>
